const BENCHMARK_PLACEHOLDER = /\[Benchmark Name\]/gi;

/** Escape HTML then restore allowed emphasis and line-break tags from catalog strings. */
export function formatRichTextHtml(raw: string): string {
  const escaped = raw
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return escaped
    .replace(/&lt;b&gt;/gi, "<b>")
    .replace(/&lt;\/b&gt;/gi, "</b>")
    .replace(/&lt;strong&gt;/gi, "<strong>")
    .replace(/&lt;\/strong&gt;/gi, "</strong>")
    .replace(/&lt;br\s*\/?&gt;/gi, "<br />")
    .replace(/\n/g, "<br />");
}

export function applyBenchmarkPlaceholder(text: string, benchmarkName?: string): string {
  if (!benchmarkName?.trim()) return text;
  return text.replace(BENCHMARK_PLACEHOLDER, benchmarkName.trim());
}

/** Bar chart disclaimer with optional `[Benchmark Name]` substitution, then rich text formatting. */
export function formatBarDisclaimerHtml(disclaimer: string, benchmarkName?: string): string {
  return formatRichTextHtml(applyBenchmarkPlaceholder(disclaimer, benchmarkName));
}
